import { REPORT_BY_COHORT_ROUTE } from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { Switch } from "react-router-dom";
import ReportByCohort from "./ReportByCohort";

function ReportByCohortView() {
  return (
    <Switch>
      <ProtectedRoute
        path={REPORT_BY_COHORT_ROUTE}
        key={REPORT_BY_COHORT_ROUTE}
        component={ReportByCohort}
        auth={true}
      />
    </Switch>
  );
}

export { ReportByCohortView };
export default ReportByCohortView;
